export const TESTIMONIALS = [
  {
    quote: "Cea mai frumoasă amintire. O ascultăm în fiecare seară.",
    author: "Adriana",
  },
  {
    quote: "Cadoul perfect! Fiul meu nu se mai satură de ea.",
    author: "Cristian",
  },
  {
    quote: "A surprins exact personalitatea fiicei mele. Super fain!",
    author: "Ioana",
  },
] as const;
